import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { DatePipe } from "@angular/common";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";

import { DataService_expressadmin } from "./shared/data.service";

import { wsOneCardExpressAdminDataInfo } from "./shared/wsOneCardExpressAdminDataInfo";
import { wsAdminIDDepotPrintQueueInfo } from "./shared/wsOneCardExpressAdminDataInfo";

import { wsOneCardExpressAdminSchoolsInfo } from "./shared/wsOneCardExpressAdminSchoolsInfo";
import { wsOneCardExpressAdminSchoolsExpressInfo } from "./shared/wsOneCardExpressAdminSchoolsInfo";
import { wsOneCardExpressAdminSchoolsPendingPrintInfo } from "./shared/wsOneCardExpressAdminSchoolsInfo";

import { SchoolInfo } from "./shared/SchoolInfo";

import { StatusComponent } from "./status/status.component";

import { ViewChild } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-root",
	templateUrl: "./expressadmin.component.html",
	styleUrls: ["./expressadmin.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class ExpressAdminComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterPrintQueueStatus", { static: false })
	public filterPrintQueueStatus: Dropdown;
	@ViewChild("filterPrintReason", { static: false })
	public filterPrintReason: Dropdown;

	constructor(
		private selectService: SchoolselectorService,
		private datepipe: DatePipe,
		private dataService: DataService_expressadmin,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;
	public SchoolSelectorMode: number = 1;

	//	Schools List
	public rOneCardExpressSchools: wsOneCardExpressAdminSchoolsInfo;
	public lstExpressSchools: wsOneCardExpressAdminSchoolsExpressInfo[] = [];
	public lstExpressSchoolsPendingPrint: wsOneCardExpressAdminSchoolsPendingPrintInfo[] = [];

	//	PrintQ List
	public rOneCardExpressData: wsOneCardExpressAdminDataInfo;
	public lstPrintQueue: wsAdminIDDepotPrintQueueInfo[] = [];
	public lstPrintQueueChecked: wsAdminIDDepotPrintQueueInfo[] = [];
	public rPrintQueueItem: wsAdminIDDepotPrintQueueInfo;

	//	Filters
	public lstPrintQueueStatuses: any = [];
	public lstPrintReasons: any = [];

	//	PrintQ Counts
	public isShowComment: boolean = false;
	public SchoolTotalPrinted: number = 0;
	public SchoolPrintedToday: number = 0;
	public SchoolTotalSubmitted: number = 0;
	public SubmitCutoffTime: Date;

	public pagefirst: number = 0;
	public pagerows: number = 25;

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	public PublicTransitLabel: string = "MTA";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.isBusy = true;
		this.dataService.OneCardExpressAdminSchoolsGet().subscribe((data) => this.OneCardExpressAdminSchoolsGet_Complete(data));

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});

		this.dataService.PublicTransitPreferenceSelect().subscribe((data: any) => {
			if (data.Success == true) {
				this.PublicTransitLabel = data.ErrorMessage;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ontoggleComment
	//
	//-----------------------------------------------------------------------------------------------------
	ontoggleComment() {
		this.isShowComment = !this.isShowComment;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRadioMode1
	//
	//-----------------------------------------------------------------------------------------------------
	onRadioMode1() {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRadioMode2
	//
	//-----------------------------------------------------------------------------------------------------
	onRadioMode2() {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.isBusy = true;
		this.dataService.OneCardExpressAdminSchoolsGet().subscribe((data) => this.OneCardExpressAdminSchoolsGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressAdminSchoolsGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressAdminSchoolsGet_Complete(data: any) {
		this.rOneCardExpressSchools = data;

		this.lstExpressSchools = this.rOneCardExpressSchools.ExpressSchoolItems;
		this.lstExpressSchoolsPendingPrint = this.rOneCardExpressSchools.ExpressSchoolPendingPrintItems;

		this.SetSchoolSelector(this.SchoolSelectorMode); // Note: Keep Busy
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressAdminDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressAdminDataGet_Complete(data: any) {
		this.rOneCardExpressData = data;

		this.lstPrintQueueChecked = [];
		this.SchoolTotalPrinted = this.rOneCardExpressData.SchoolTotalPrinted;
		this.SchoolPrintedToday = this.rOneCardExpressData.SchoolPrintedToday;
		this.SchoolTotalSubmitted = this.rOneCardExpressData.SchoolTotalSubmitted;
		this.SubmitCutoffTime = this.rOneCardExpressData.SubmitCutoffTime;
		this.lstPrintQueue = this.rOneCardExpressData.PrintQueueItems;

		//
		//	Set Filter Lists
		//
		this.lstPrintQueueStatuses = Array.from(new Set(this.lstPrintQueue.map((item: any) => item.IDDepotPrintQueueStatusDesc)));
		this.lstPrintReasons = Array.from(new Set(this.lstPrintQueue.map((item: any) => item.IDDepotPrintReasonDesc)));

		//
		//	Reset Filters
		//
		this.onClearFilters();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "SubmittedDT", order: -1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterPrintQueueStatus.clear(null);
		this.filterPrintReason.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onChangeStatus
	//
	//-----------------------------------------------------------------------------------------------------
	onChangeStatus() {
		if (this.lstPrintQueueChecked.length < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no selected items in the print queue.",
				header: "Change Status",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});

			return;
		} else {
			var ref = this.dialogService.open(StatusComponent, {
				header: "Change Status",
				width: "400px",
				data: {
					UserPersonID: this.user.personID,
					SchoolID: this.SelectedSchool.SchoolID,
					lstPrintQueueChecked: this.lstPrintQueueChecked,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueonChangeStatus_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueonChangeStatus_Complete(data: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {
		this.lstPrintQueueChecked = [];
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SetSchoolSelector
	//
	//-----------------------------------------------------------------------------------------------------
	SetSchoolSelector(mode: number) {
		let isItemFound: boolean = false;
		let isSchoolSelected: boolean = false;

		//
		//	Note:
		//		MODE#1 = Express Schools With Pending Print
		//		MODE#2 = All Express Schools
		//
		if (mode == 1) {
			this.lstSchool = this.lstExpressSchoolsPendingPrint;
		} else {
			this.lstSchool = this.lstExpressSchools;
		}

		//
		//	Add the [- Select a school -] to the top of the list
		//
		//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
		//		this allows it to show with a visual appeal that matches the rest of the items.
		//
		// this.lstSchool.unshift(
		// 	{
		// 		SchoolID: -1,
		// 		SchoolNumber: "- Select a school",
		// 		SchoolName: ""
		// 	});

		//
		//	if PreSelectSchoolID has a value not equal -1 then try to select the item
		//
		this.lstSchool.forEach((item) => {
			item.SchoolFullName = item.SchoolNumber + " - " + item.SchoolName;

			// if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1)
			// {
			// this.SelectedSchool = item;
			// isItemFound = true;
			// isSchoolSelected = true;
			// }
		});

		//
		//	if PreSelectSchoolID was not found
		//
		//if (isItemFound == false)
		//{
		//	//
		//	//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
		//	//	then select it. otherwise select the [- Select a School -] item.
		//	//
		//	if (this.lstSchool.length == 2)
		//	{
		//		if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID)
		//		{
		//			this.SelectedSchool = this.lstSchool[1];
		//			isSchoolSelected = true;
		//		}
		//		else
		//		{
		//			this.SelectedSchool = this.lstSchool[0];
		//		}
		//	}
		//	else
		//	{
		//		this.SelectedSchool = this.lstSchool[0];
		//	}
		//}

		//if (isSchoolSelected == true)
		//{
		// this.isBusy = true;
		//
		// var inSchoolList = false;
		// for(var z = 0; z < this.lstSchool.length; z++){
		// var next = this.lstSchool[z];
		//
		// if(this.SelectedSchool.SchoolID == next.SchoolID){
		// inSchoolList = true;
		// break;
		// }
		// }
		//
		// if(inSchoolList == true){
		// this.dataService.OneCardExpressAdminDataGet(this.SelectedSchool.SchoolID).subscribe(data => this.OneCardExpressAdminDataGet_Complete(data));
		// }
		// else{
		// this.dataService.OneCardExpressAdminDataGet(-1).subscribe(data => this.OneCardExpressAdminDataGet_Complete(data));
		// }

		//}
		//else
		//{
		//	this.isBusy = true;
		//	this.dataService.OneCardExpressAdminDataGet(-1).subscribe(data => this.OneCardExpressAdminDataGet_Complete(data));
		//}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		this.SelectedSchool = value;

		//if (this.SelectedSchool.SchoolID > 0)
		//{
		//	this.PreSelectSchoolID = this.SelectedSchool.SchoolID

		this.isBusy = true;

		var inSchoolList = false;
		for (var z = 0; z < this.lstSchool.length; z++) {
			var next = this.lstSchool[z];

			if (this.SelectedSchool.SchoolID == next.SchoolID) {
				inSchoolList = true;
				break;
			}
		}

		if (inSchoolList == true) {
			this.dataService.OneCardExpressAdminDataGet(this.SelectedSchool.SchoolID).subscribe((data) => this.OneCardExpressAdminDataGet_Complete(data));
		} else {
			this.dataService.OneCardExpressAdminDataGet(-1).subscribe((data) => this.OneCardExpressAdminDataGet_Complete(data));
		}

		//}
		//else
		//{
		//	this.PreSelectSchoolID = -1;
		//
		//	this.isBusy = true;
		//	this.dataService.OneCardExpressAdminDataGet(-1).subscribe(data => this.OneCardExpressAdminDataGet_Complete(data));
		//}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
